import { useCallback, useEffect, useRef, useState } from 'react'

interface UseResendCooldownResult {
  segundosRestantes: number
  emCooldown: boolean
  reiniciar: () => void
  reiniciarCom: (segundos: number) => void
}

export default function useResendCooldown(
  duracaoPadrao = 60
): UseResendCooldownResult {
  const [segundosRestantes, setSegundosRestantes] =
    useState<number>(duracaoPadrao)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const iniciar = useCallback((segundos: number) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
    setSegundosRestantes(segundos)
    if (segundos <= 0) return

    intervalRef.current = setInterval(() => {
      setSegundosRestantes((prev) => {
        if (prev <= 1) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
          }
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }, [])

  useEffect(() => {
    iniciar(duracaoPadrao)
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const reiniciar = useCallback(
    () => iniciar(duracaoPadrao),
    [iniciar, duracaoPadrao]
  )
  const reiniciarCom = useCallback(
    (segundos: number) => iniciar(segundos),
    [iniciar]
  )

  return {
    segundosRestantes,
    emCooldown: segundosRestantes > 0,
    reiniciar,
    reiniciarCom,
  }
}